import { createVNode, render } from 'vue'
import ToastComponent from './toast.vue'

// 创建或获取 toast 容器
let toastContainer = document.querySelector('.xy-toast-container')
if (!toastContainer) {
  toastContainer = document.createElement('div')
  toastContainer.setAttribute('class', 'xy-toast-container')
  document.body.appendChild(toastContainer)
}

// toast队列状态管理
const toastQueue = [] // 存储待显示的 Toast
let isShowing = false // 标记当前是否正在显示 Toast
let currentMessage = null // 当前正在展示的 Toast 文案（用于同文案去重）
let pendingToastCount = 0 // 计数器，记录当前待显示的 Toast 数量

const processQueue = () => {
  if (toastQueue.length === 0 || isShowing) return
  isShowing = true
  pendingToastCount = toastQueue.length // 记录当前队列中的 Toast 数量

  // 从队列中取出下一个要显示的 Toast
  const { message, duration, type, onClose } = toastQueue.shift()
  currentMessage = message

  const div = document.createElement('div')
  div.setAttribute('class', 'xy-toast-wrapper')
  toastContainer.appendChild(div)

  const vnode = createVNode(ToastComponent, { message, type })
  render(vnode, div)

  setTimeout(() => {
    render(null, div)
    if (toastContainer.contains(div)) {
      toastContainer.removeChild(div)
    }
    if (onClose) {
      onClose()
    }
    currentMessage = null
    isShowing = false
    processQueue()
  }, duration)
}

// 创建Toast
const createToast = ({ message, duration = 1500, type = 'text', onClose }) => {
  // 同文案去重：正在展示或已在队列中的相同文案直接丢弃，避免持续触发时连环 toast
  if (currentMessage === message || toastQueue.some((item) => item.message === message)) return
  toastQueue.push({ message, duration, type, onClose })
  processQueue()
}

const Toast = (options) => {
  return createToast(options)
}

Toast.clearAll = () => {
  if (pendingToastCount === 0) {
    return // 如果没有待显示的 Toast，则直接返回
  }

  // 清空队列和容器中的所有 Toast
  toastQueue.length = 0
  const toasts = document.querySelectorAll('.xy-toast-wrapper')
  toasts.forEach((toast) => {
    render(null, toast)
    if (toastContainer.contains(toast)) {
      toastContainer.removeChild(toast)
    }
  })

  isShowing = false
  currentMessage = null
  pendingToastCount = 0
}

export default Toast
